import moment from "moment";

export default function tickets(
  initialState = {
    tickets: [],
    tables: [],
    search: '',
    ticketList: [],
    startDate: moment().startOf('month').toISOString(),
    endDate: moment().endOf('month').toISOString(),
    activeSort: '',
    sortOrder: '',
    totalCount: 0,
    page: 1
  },
  action
) {
  switch (action.type) {
    case 'SET_RESTAURANT_ADMIN_TICKET':
      return {
        ...initialState,
        ticketList: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TICKET_LIST':
      return {
        ...initialState,
        ticketList: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TICKET_TABLES':
      return {
        ...initialState,
        tickets: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TICKET_SEARCH':
      return {
        ...initialState,
        search: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TICKET_START_DATE':
      return {
        ...initialState,
        startDate: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TICKET_END_DATE':
      return {
        ...initialState,
        endDate: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TICKET_ACTIVE_SORT':
      return {
        ...initialState,
        activeSort: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TICKET_SORT_ORDER':
      return {
        ...initialState,
        sortOrder: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TICKET_TOTAL_COUNT':
      return {
        ...initialState,
        totalCount: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TICKET_PAGE':
      return {
        ...initialState,
        page: action.payload,
      };


    case 'RESTAURANT_ADMIN_TICKET_RESET':
      return {
        ...initialState,
        tickets: [],
        tables: [],
        search: '',
        startDate: moment().startOf('month').toISOString(),
        endDate: moment().endOf('month').toISOString(),
        activeSort: '',
        sortOrder: '',
        totalCount: 0,
        page: 1
      };

    default:
      return initialState;
  }
}
